<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <ValidationObserver ref="taskForm" v-slot="{ handleSubmit }">

          <form class="form-container" ref="formContainer" id="task-view-instance"
            @submit.prevent="handleSubmit(onClickSubmitTaskInstance)" autocomplete="off">
            <div class="floating-buttons" :class="{ sticky: isSticky }"
              v-if="validForm == true && $canAny(['sign-off-scheduled-tasks'])">
              <div v-for="option in signOffOptions" :key="option.value" class="signOffOptions">
                <vs-button @click="signOff(option)" button="button" :color="getButtonColor(option)" type="border"
                  icon-pack="feather" :icon="getIcon(option)" class="mr-2">
                  <span v-if="option.value === 'Approved'" class="mr-1"> Approve</span>
                  <span v-else-if="option.value === 'Rejected'" class="mr-1"> Reject</span>

                </vs-button>
              </div>
            </div>
            <h4 color="primary">Complete tasks below</h4>
            <div v-for="(field, index) in form.scheduled_task_schedule.scheduled_task_template.fields" :key="index">
              <div :class="{ 'error-border': field.error }" class="taskBox">
                <h4 class="mt-4 flex">{{ index + 1 }} . {{ field.label }} </h4>
                <div class="w-full vx-col md:w-3/3  md:mb-0">
                  <h4 class="mt-4"></h4>
                  <div v-if="field.description">
                    <small class="label">Description</small>
                    <div class="textarea-display mb-2">
                      <span>{{field.description}}</span>
                    </div>
                  </div>
                  <div v-if="field.type == 'Boolean'" class="flex mt-2">
                      <YesNoToggle v-model="field.value"  @input="val => handleScaleChange(index, val)" />
                  </div>
                  <div class="vx-row mb-3">
                    <div class="w-full vx-col md:w-3/3 md:mb-0">
                      <vs-textarea v-if="field.type == 'Text'" v-model="field.value" :rows="5"></vs-textarea>
                    </div>
                    <div class="vx-col md:w-1/3 md:mb-0">

                      <flat-pickr v-if="field.type == 'Date'" class="w-full" :config="flatPkrConfig"
                        v-model="field.value" placeholder="Choose Date" />
                      <v-select v-if="field.type == 'Drop Down'" id="type" v-model="field.value"
                        :options="field.options != null ? field.options.labels : []" :reduce="option => option.label"
                        placeholder="Select an option" />

                      <RangeScale v-if="field.type == 'Scale'" v-model="field.value" :min="field.options.min"  @input="val => handleScaleChange(index, val)"
                        :max="field.options.max" :labels="field.options.labels" />
                    </div>
                    <div v-if="field.type === 'Table'" class="w-full vx-col">
                      <!-- TABLE VIEW -->
                      <div class="mt-4 overflow-auto">
                     <vs-table 
                        :data="field.options.table.rows" 
                        stripe 
                        class="table-dark-inverted table-auto vs-con-loading__container"
                      >
                        <!-- Table Header -->
                        <template slot="thead">
                          <vs-th   style="max-width: 20%;" v-for="(col, cIndex) in field.options.table.columns" :key="cIndex">
                            {{ col }}
                          </vs-th>
                          <vs-th v-if="field.options.table.is_repeatable">Actions</vs-th> <!-- Extra column for delete button -->
                        </template>

                        <!-- Table Body -->
                        <template slot-scope="{ data }">
                          <vs-tr v-for="(row, rIndex) in data" :key="rIndex">
                            <vs-td v-for="(col, cIndex) in field.options.table.columns" :key="cIndex">
                              <vs-input
                                v-model="field.options.table.rows[rIndex][col]"
                                placeholder="Enter value"
                                @input="val => handleChange(index, rIndex, col, val)"
                              ></vs-input>
                            </vs-td>
                             <vs-td v-if="field.options.table.is_repeatable">
                              <vs-button
                                class="mr-2"
                                size="small"
                                color="danger"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="deleteTableRow(index, rIndex)" 
                              ></vs-button>
                          </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>

                        <vs-button v-if="field.options.table.is_repeatable" type="filled" color="success" icon-pack="feather" icon="icon-plus"
                          style="margin-top: 10px;" @click="addRow(index)">
                          Add Row
                        </vs-button>
                      </div>


                    </div>

                  </div>
                </div>
                <vs-input v-model="field.value" :danger="!!field.error" </vs-input>

                  <vs-alert v-if="field.error" color="danger" icon="warning" icon-pack="feather" :border="false"
                    class="mt-1">
                    {{ field.error }}
                  </vs-alert>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button button="submit" class="mt-2 ml-auto">Submit Task</vs-button>
            </div>

          </form>
        </ValidationObserver>
        <vs-popup :title="popupTitle" v-model="popupOpen" position="top-right" :active.sync="popupOpen">
          <div class="popup-content">
            <small class="label">Add a comment</small>
            <vs-textarea v-model="comment" placeholder="Type your comment..." rows="4"></vs-textarea>
            <div style="margin-top: 10px; display: flex; justify-content: flex-end; gap: 5px;">
              <vs-button color="danger" type="border" icon-pack="feather" @click="closePopup">Cancel</vs-button>
              <vs-button color="success" type="border" icon-pack="feather" @click="submitComment">Submit</vs-button>
            </div>
          </div>
        </vs-popup>

      </vx-card>
    </div>
  </div>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import ScheduledTasksRepository from "@/repository/ScheduledTasksRepository";
  import flatPickr from "vue-flatpickr-component";
  import RangeScale from '../../../components/range-scale/rangeScale.vue';
  import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

  export default {
    name: "task-instance-view",
    components: {
      'v-select': vSelect,
       flatPickr,
       RangeScale,
       YesNoToggle
    },
    data: function() {
      return {
        id: '',
        form: {
          scheduled_task_schedule : {
            scheduled_task_template : {}
          }
        },
        taskTemplates: [],
        staffs:[],
        signOffOptions:[],
        signOffValue : '',
        dataLoaded: false,
        validForm: false,
        isSticky: false,
        topOffset: 0 ,
        comment:'',
        popupOpen : false,
        popupTitle : ''

        }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
        this.id = this.$route.params.id
         window.addEventListener('scroll', this.handleScroll);
        this.topOffset = this.$refs.formContainer.getBoundingClientRect().top + window.scrollY;
        await this.getTaskInstanceStatus()
        await this.fetchTaskInstance()
        if(this.form.status == 'Pending'){
        await this.startTaskInstance()
        }
    },
    beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    },
   methods: {
      searchStaff: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getStaffList(`filter[search]=${search}`)
      vm.staffs = data.data
      loading(false);
    }, 350),
      searchTemplates: _.debounce( async (loading, search, vm) => {
      const {data} = await ScheduledTasksRepository.list(`filter[search]=${search}`)
      vm.taskTemplates = data.data
      loading(false);
      }, 350),
      async getTaskInstanceStatus() {
        await this.$vs.loading({
          container: '#task-view-instance',
          scale: 0.45
        })
        try {
        const {data} = (await ScheduledTasksRepository.getTaskInstanceStatus(this.id))
        this.signOffOptions = data.data.reverse();
        } catch (e) {
          this.convertAndNotifyError(e)
        }
       this.$vs.loading.close('#task-view-instance > .con-vs-loading')
      },
      async fetchTaskInstance() {
        await this.$vs.loading({
          container: '#task-view-instance',
          scale: 0.45
        })
        try {
          const {data} = (await ScheduledTasksRepository.getTaskInstance(this.id))
          this.form = data.data;
          this.form.scheduled_task_schedule.scheduled_task_template.fields = 
          this.form.scheduled_task_schedule.scheduled_task_template.fields.map((item, i) => {
              // Initialize table options if missing
              if (item.type === "Table") {
                if (!item.options.table) item.options.table = {};
                if (!item.options.table.columns) item.options.table.columns = [];
                if (!item.options.table.rows) item.options.table.rows = [];
              }
              if(item.type === "Boolean"){
                item.value = false;
              }

              // Set existing saved value
              if (this.form.responses[i]) {
                this.form.scheduled_task_schedule.scheduled_task_template.fields[i] = this.form.responses[i].fieldSnapshot
                item.value = this.form.responses[i].value;

                if (item.type === "Table") {
                  item.options.table.rows = item.value;
                }
              } else {
                // If table is not repeatable and no saved value, add an initial row
                if (item.type === "Table" && item.options.table.is_repeatable === false) {
                  const emptyRow = {};
                  item.options.table.columns.forEach(col => {
                    emptyRow[col] = ""; // initialize empty values
                  });
                  item.options.table.rows.push(emptyRow);
                }
              }
              return item;
          });
          if(this.form.scheduled_task_schedule.scheduled_task_template.fields.length == this.form.responses.length){
            this.validForm = true;
          }
          
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#task-view-instance > .con-vs-loading')
      },
    async onClickSubmitTaskInstance() {
  await this.$vs.loading({
    container: '#task-view-instance',
    scale: 0.45
  });

  try {
    const fields = this.form.scheduled_task_schedule.scheduled_task_template.fields;

    let hasErrors = false;

    // Ensure each field has a reactive 'error' property
    fields.forEach(field => {
      if (field.error === undefined) {
        this.$set(field, 'error', null);
      } else {
        field.error = null; // reset previous errors
      }
    });

    // Validate required & active fields
    fields.forEach(field => {
      const isRequired = field.is_required && field.is_active;
      const isEmpty = field.value === null || field.value === undefined || String(field.value).trim() === "";

      if (isRequired && isEmpty) {
        field.error = `${field.label || 'Field'} is required`;
        hasErrors = true;
      }
    });

    // Stop submission if validation failed
    if (hasErrors) {
      this.$vs.loading.close('#task-view-instance > .con-vs-loading');
      return;
    }

    // Build submit data
    const submitData = {
      responses: fields.map(field => {
      let value;

      if (field.type === 'Table') {
        // If it's a table field, take all rows for the table
        value = field.options.table.rows
      } else {
        // For normal fields, use the value directly
        value = field.value;
      }

      return {
        field_id: field.id,
        value: value,
        comment: " "
      };
    })
    };

    // Submit task instance
    await ScheduledTasksRepository.submitTaskInstance(this.id, submitData);

    this.showSuccessMessage('Task added successfully');

    await ScheduledTasksRepository.completeTaskInstance(this.id);

    this.$router.push({ path: `/pages/task-instance` });

  } catch (e) {
    this.convertAndNotifyError(e);
  }

  this.$vs.loading.close('#task-view-instance > .con-vs-loading');
}
,
      onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
      },
      onSearchTemplate(search, loading) {
      if(search.length) {
        loading(true);
        this.searchTemplates(loading, search, this);
      }
      },
      onClickBack() {
        this.$router.push({path: `/pages/settings?tab=staff+scheduled_task_templates`})
      },
      signOff(option) {
          this.comment = '';
          this.popupOpen = true;
          this.signOffValue = option;
          if(option.value === 'Approved'){
            this.popupTitle = 'Approve'
          }
          if(option.value === 'Rejected'){
            this.popupTitle = 'Reject'
          }
               
      },
      closePopup() {
      this.popupOpen = false;
      },
      async submitComment() {
        const vue = this;
        await this.$vs.loading({
          container: '#task-view-instance',
          scale: 0.45
        })
        try {
        let payload = {
          status: this.signOffValue.value,
          comment: this.comment
        }
        await ScheduledTasksRepository.signOffTaskInstance(this.id, payload);
        this.showSuccessMessage('Task added successfully');
        this.popupOpen = false;
        this.$nextTick(() => {
          this.$router.push({ path: '/pages/task-instance' });
        });
        // handle submission
        } catch (e) {
          this.$vs.loading.close('#task-view-instance > .con-vs-loading')
          this.convertAndNotifyError(e)
          this.popupOpen = false;
        }
        this.$vs.loading.close('#task-view-instance > .con-vs-loading')
      },
      handleScroll() {
      const formTop = this.$refs.formContainer.getBoundingClientRect().top;
      this.isSticky = formTop < 100;
    },
      getIcon(option){
        if(option.value === 'Approved'){
          return 'icon-check'
        }
        if(option.value === 'Rejected'){
          return 'icon-x'
        }
        else {
          return ''
        }
      },
      getButtonColor(option) {
        if(option.value === 'Approved'){
          return 'primary'
        }
        if(option.value === 'Rejected'){
            return 'danger'
          }
        else {
          return ''
        }
      },
      async startTaskInstance(){
        const vue = this;
        await this.$vs.loading({
          container: '#task-view-instance',
          scale: 0.45
        })
        try {
        let payload = {
          status: this.signOffValue.value,
          comment: this.comment
        }
        await ScheduledTasksRepository.startTaskInstance(this.id, payload);
        this.showSuccessMessage('Task started successfully');
        // handle submission
        } catch (e) {
          this.$vs.loading.close('#task-view-instance > .con-vs-loading')
          this.convertAndNotifyError(e)
          this.popupOpen = false;
        }
        this.$vs.loading.close('#task-view-instance > .con-vs-loading')
      },
  handleChange(fIndex, rIndex, col, val) {
      const field = this.form.scheduled_task_schedule.scheduled_task_template.fields[fIndex];

      // Update the nested row value
      this.$set(field.options.table.rows[rIndex], col, val);

      // Force Vue to re-render the inputs to fix vs-input display issues
      this.form.scheduled_task_schedule.scheduled_task_template.fields = [
        ...this.form.scheduled_task_schedule.scheduled_task_template.fields
      ];
    },
     handleScaleChange(fIndex, val) {
    // Update the nested field value
    const field = this.form.scheduled_task_schedule.scheduled_task_template.fields[fIndex];

    // Use $set to ensure reactivity
    this.$set(field, 'value', val);

    // Optional: force re-render of the fields array (like your table trick)
    this.form.scheduled_task_schedule.scheduled_task_template.fields = [
      ...this.form.scheduled_task_schedule.scheduled_task_template.fields
    ];
  },
    addRow(fIndex) {
      const field = this.form.scheduled_task_schedule.scheduled_task_template.fields[fIndex];
      const table = field.options.table;

      const newRow = {};
      table.columns.forEach(col => this.$set(newRow, col, '')); // initialize empty strings
      table.rows.push(newRow);

      // Trigger reactivity at the parent level so inputs render correctly
      this.form.scheduled_task_schedule.scheduled_task_template.fields = [
        ...this.form.scheduled_task_schedule.scheduled_task_template.fields
      ];
    },
    deleteTableRow(fieldIndex, rowIndex) {
      const rows = this.form.scheduled_task_schedule.scheduled_task_template.fields[fieldIndex].options.table.rows;
      rows.splice(rowIndex, 1);
    }
          
    },
     computed:{
        flatPkrConfigDisabled(){ 
        return {
            dateFormat: 'd/m/Y',
            allowInput: false, // disables typing
            clickOpens: false, // disables calendar popup
        }
      },
         flatPkrConfig(){
          return {
             dateFormat: 'd/m/Y',
          }
         }
    },
  }
</script>
<style>
.taskBox {
    border: solid 2px;
    border-radius: 8px;
    padding: 20px 20px 40px 20px;
    margin: 40px 0px;
}

.taskBox:first-child {
  margin-top: 20px;
}

.textarea-display {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: inherit;

  max-height: 200px;   /* set your desired max height */
  overflow-y: auto;    /* scroll if content is too big */
  white-space: pre-wrap; /* preserves line breaks */
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fafafa;
}

.signOffOptions{
  background: #ffffff;
}

.theme-dark {
  .textarea-display {
   background: #262c49;
  }
  .signOffOptions{
   background: #10163a;
  }
}

.form-container {
  position: relative;
}

.floating-buttons {
  position: absolute !important;
  right: 0;
  top: -10px;
  display: flex;
  flex-direction: row;
}

.floating-buttons.sticky {
  position: fixed !important;
  top: 100px;
  right: 55px;
}

.error-text {
  color: red;
  font-size: 13px;
}

.error-border {
  border: 1px solid rgba(var(--vs-danger),1);
}
</style>
